/**
 * ! Currently, rounding number to one decimal place is removed according last request of the client
 * ! If needed again, please use the code below
 * * return num >= 1 ? Math.round(num) : +(Math.round(Number(num + "e+1")) + "e-1")
 */
export const roundNumber = (num: number) => Math.round(num);
